import { useContext } from 'react'
import {
  FunctionalDiagramEditContext,
  RESET_CIRCUIT_PINS,
  SET_CIRCUIT_PINS,
  SET_RELATED_CONNECTORS,
} from './context/context'
import { Data } from '@styled-icons/boxicons-solid'
import ComponentSearchPinsRows from './ComponentSearchPinsRows'
import ComponentSearchDevicePins from './ComponentSearchDevicePins'
import Button from '../../../common/Button'
import { getRequest } from '../../../../services/base'
import { createSearchParams, useParams } from 'react-router-dom'
import ConnectorInfo from '../../../connector_views/connector_mapping/ConnectorInfo'
import RelatedConnectorsRow from '../../../dtcs/TATMappings/ConnectorMapping/SelectConnectorSection/RelatedConnectorsRow'
import { NavContext } from '../../../../context/global_context'

const ComponentSearchPins = () => {
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)
  const { vehicle } = useParams()

  const getRelatedConnectors = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Fetching Related Connectors`,
        showLoader: true,
      },
      notification: {},
    })

    let circuit_ids = [],
      pins = [],
      connector_names = []
    state?.selectedCircuitPins?.forEach((row, index) => {
      circuit_ids.push(row.split('**$$')[0])
      pins.push(row.split('**$$')[1])
      connector_names.push(row.split('**$$')[2])
    })
    let res = await getRequest(
      `/api/dtcs/related_connectors/?${createSearchParams({
        circuit_ids: circuit_ids,
        search_old_levels: true,
        dtc_mapping_type: 'end',
        vehicle_id: vehicle,
        connector_name: connector_names,
        pins: pins,
        is_dtc: false,
      })}`
    )
    dispatch({ type: SET_RELATED_CONNECTORS, data: res.data })
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <div className="w-full">
      <div className="flex justify-between text-sm pt-2">
        <div className="py-1 px-3 bg-tracer-lt-blue text-white cursor-pointer flex text-base font-medium items-center">
          Component :{' '}
          {state?.selectedSectionRecord?.name
            ? state?.selectedSectionRecord?.name
            : '-'}
        </div>
      </div>
      <div
        className="bg-white px-2"
        style={{ height: '60vh', overflowY: 'scroll' }}
      >
        {state?.selectedSection?.type === 'devices' ? (
          <ComponentSearchDevicePins />
        ) : (
          <ComponentSearchPinsRows />
        )}
      </div>
      {state?.selectedCircuitPins?.length > 0 && (
        <div className="flex items-center text-white text-center font-medium justify-between py-6">
          <Button
            type="submit"
            className={`cursor-pointer btn`}
            onClick={(e) => {
              getRelatedConnectors()
            }}
            value={'text'}
            text={'Filter Connectors'}
          />
          <Button
            type="submit"
            className={`cursor-pointer btn `}
            onClick={(e) => {
              dispatch({ type: RESET_CIRCUIT_PINS, data: [] })
            }}
            value={'text'}
            text={'Clear Selection'}
          />
        </div>
      )}
    </div>
  )
}

export default ComponentSearchPins
